import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {
  constructor() {}
  // Custom validator for at least one uppercase letter
  public uppercaseValidator() {
    return (control: AbstractControl) => {
      const hasUppercase = /[A-Z]+/.test(control.value);
      return hasUppercase ? null : { uppercase: true };
    };
  }

  // Custom validator for at least one lowercase letter
  public lowercaseValidator() {
    return (control: AbstractControl) => {
      const hasLowercase = /[a-z]+/.test(control.value);
      return hasLowercase ? null : { lowercase: true };
    };
  }

  // Custom validator for at least one number
  public numberValidator() {
    return (control: AbstractControl) => {
      const hasNumber = /[0-9]+/.test(control.value);
      return hasNumber ? null : { number: true };
    };
  }
}
